import TabletopViewport from "../../objects/TabletopViewport";
import type { Point2d } from "../../../../common/geometry/Geom2d";

export default class TabletopCanvasMouseEvent {
    private _viewportPosition: Point2d;
    private _universePosition: Point2d;
    private _movement: Point2d;
    private _button: number;
    private _buttons: number;
    private _altKey: boolean;
    private _ctrlKey: boolean;
    private _shiftKey: boolean;

    public constructor(e: MouseEvent, viewport: TabletopViewport) {
        const viewportPosition = { x: e.offsetX, y: e.offsetY };
        const universePosition =
            viewport.viewportPointToUniversePoint(viewportPosition);

        this._viewportPosition = viewportPosition;
        this._universePosition = universePosition;
        this._movement = { x: e.movementX, y: e.movementY };
        this._button = e.button;
        this._buttons = e.buttons;
        this._altKey = e.altKey;
        this._ctrlKey = e.ctrlKey;
        this._shiftKey = e.shiftKey;
    }

    public get viewportPosition() {
        return this._viewportPosition;
    }

    public get universePosition() {
        return this._universePosition;
    }

    public get movement() {
        return this._movement;
    }

    public get button() {
        return this._button;
    }

    public get buttons() {
        return this._buttons;
    }

    public get altKey() {
        return this._altKey;
    }

    public get ctrlKey() {
        return this._ctrlKey;
    }

    public get shiftKey() {
        return this._shiftKey;
    }
}
